import {
  createRouter,
  createWebHashHistory
} from 'vue-router'
import defaultPage from '@/views/default.vue'

const routes = [{
  path: '/',
  name: 'defaultPage',
  redirect: '/home',
  component: defaultPage,
  children: [{
    path: '/home',
    name: 'home',
    component: () => import('../views/home/home.vue'),
    meta: {
      keepAlive: true,
      title: '首页 - 悦唯医疗'
    }
  }, {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('../views/aboutUs/aboutUs.vue'),
    meta: {
      keepAlive: true,
      title: '关于我们 - 企业介绍'
    }
  }, {
    path: '/prize',
    name: 'prize',
    component: () => import('../views/aboutUs/prize.vue'),
    meta: {
      keepAlive: true,
      title: '关于我们 - 获奖与称号'
    }
  }, {
    path: '/products',
    name: 'products',
    component: () => import('../views/products/products.vue'),
    meta: {
      keepAlive: true,
      title: '产品中心 - 悦唯医疗'
    }
  }, {
    path: '/productDetail',
    name: 'productDetail',
    component: () => import('../views/products/productDetail.vue'),
    meta: {
      keepAlive: false,
      title: '产品详情 - 悦唯医疗'
    }
  }, {
    path: '/academic',
    name: 'academic',
    component: () => import('../views/academic/academic.vue'),
    meta: {
      keepAlive: true,
      title: '学术资讯 - 悦唯医疗'
    }
  }, {
    path: '/news',
    name: 'news',
    component: () => import('../views/news/news.vue'),
    meta: {
      keepAlive: true,
      title: '企业动态 - 悦唯医疗'
    }
  }, {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/contact/contact.vue'),
    meta: {
      keepAlive: true,
      title: '联系我们 - 悦唯医疗'
    }
  }, {
    path: '/articleDetail',
    name: 'articleDetail',
    component: () => import('../views/article/articleDetail.vue'),
    meta: {
      keepAlive: false,
      title: '文章详情 - 悦唯医疗'
    }
  }, {
    path: '/newsDetail',
    name: 'newsDetail',
    component: () => import('../views/article/newsDetail.vue'),
    meta: {
      keepAlive: false,
      title: '新闻详情 - 悦唯医疗'
    }
  }]
}]
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
